import { Button, Typography } from "@mui/material";
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
import axios from "axios";
import React from "react";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { BASE_URL, CONTACT_VERIFY } from "../utills/ApplicationRouting";
import toast from "react-hot-toast";

function ContactVerify() {
    const { token, contact, email } = useSelector((state) => state.qps);
  const navigate = useNavigate();
  const handleGetOtp = async () => {

    
    const otpPostData = { email: email, contact: contact };

    // Debugging logs
    console.log("Token:", token);
    console.log("Contact:", contact);
    console.log("Email:", email);
    console.log("Payload being sent:", otpPostData);

    try {
      const response = await axios.post(
        `${BASE_URL}${CONTACT_VERIFY}`,
        otpPostData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        navigate("/otp");
        console.log("OTP Sent");
      }
    } catch (error) {
      console.log(error);
      
      if (error.response && error.response.data) {
        const errors = error.response.data; 
        if (typeof errors === "object") {
       
          Object.keys(errors).forEach((key) => {
            console.log(`${errors[key]}`); 
            toast.error(`${errors[key]}`); 
          });
        } else {
          toast.error(errors); 
        }
      } 
    }
  };
  return (
    <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center">
        <Typography
  variant="h6"
  component="span"
  align="center"
  className="block w-full font-bold text-red-600"
>
  Contact Not Verified
</Typography>

<br />
        <p className="text-gray-600 text-base mb-6">
  Please verify your contact number to continue using your account.
</p>
        <Button
  variant="contained"
  fullWidth
  onClick={handleGetOtp}
  sx={{
    backgroundColor: "#153E75",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    py: 1,
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }}
>
  Get OTP
</Button>
<br />

<div className="text-gray-600 text-center" style={{ fontSize: "10px" }}>
  A verification code will be sent to your registered contact number.
</div>
      </div>
    </div>
    </CommonContainer>
</div>
  )
}

export default ContactVerify
